// MetadataContext.js
import { createContext, useState, useEffect } from 'react';
import { Global } from '../Variables/Global';

export const MetadataContext = createContext();

export const MetadataProvider = ({ children }) => {
  const [metadata, setMetadata] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMetaData();
    setLoading(false);
  }, []);

    const getMetaData = async () => {
        const URL = Global.API_URL + "MetaData/GetMetaDatas";
        const response = await fetch(URL);
        if (!response.ok) throw Error("Did Not Receive expected data");
        const listItems = await response.json();
        setMetadata(listItems);
      };

  return (
    <MetadataContext.Provider value={{ metadata, loading }}>
      {children}
    </MetadataContext.Provider>
  );
};
